package kz.dentalcrm.app.screens.login

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.domain.AuthRepository
import kz.dentalcrm.app.screens.login.mvi.LoginViewEvent
import kz.dentalcrm.app.screens.login.mvi.LoginViewSideEffect
import kz.dentalcrm.app.screens.login.mvi.LoginViewState
import org.koin.core.component.inject

class LoginViewModel : BaseStateViewModel<LoginViewEvent, LoginViewState, LoginViewSideEffect>() {

    private val authRepository: AuthRepository by inject()

    override fun setInitialState() = LoginViewState()

    override fun handleEvents(event: LoginViewEvent) {
        when (event) {
            is LoginViewEvent.Login -> login(event.email, event.password)
            LoginViewEvent.ResetError -> setState { copy(error = null) }
        }
    }

    private fun login(email: String, password: String) {
        setState { copy(isLoading = true) }
        launch(Dispatchers.Default) {
            try {
                when (val result = authRepository.login(email, password)) {
                    is Result.Success -> {
                        authRepository.saveCredo(
                            email = email,
                            password = password,
                            token = result.value.token,
                        )
                        setEffect { LoginViewSideEffect.NavigateToMain }
                    }

                    is Result.Error -> {
                        setState { copy(error = result.message ?: "Неверный логин или пароль") }
                    }

                    else -> {
                        setState { copy(error = "Ошибка, проверьте введенные данные") }
                    }
                }
            } catch (ex: Exception) {
                setState { copy(error = "Ошибка, проверьте введенные данные") }
            } finally {
                setState { copy(isLoading = false) }
            }
        }
    }
}
